import React, { useState, useEffect, useNavigate } from 'react';
import Iicon from './images/Group 3440.svg';
import sridevi from './images/Shridevi.svg';
import chary from './images/Chary.jfif'
import Info from './Info.js';

// import ReactPlayer from 'react-player';

function WellLogAnalysis({ inputVideoUrl }) {
    const [showModal, setShowModal] = useState(false);
    const handleToggleModal = () => {
        setShowModal(!showModal);
    };

    const infocontent = {
        "description": [
            "The GenAI-powered Well Log Analysis app simplifies complex well log analysis.",
            "Users upload well log data which is automatically transformed into interactive dashboards.",
            {
                mainPoint: "Two key sections:",
                subPoints: [
                    "Overview: For quick summaries.",
                    "Detailed Analysis: For deeper insights with graphs and explanations."
                ]
            },
            "Designed to democratize access, making interpretation easy for all users."
        ],
        "BusinessValueProposition": [
            "Automates complex data analysis.",
            "Empowers users of all technical backgrounds.",
            "Speeds up and simplifies decision - making.",
            "Cost - effective by reducing need for specialists.",
            "Enables offline sharing of results."
        ],
        "problemStatement": [
            "Traditional well log analysis is time-consuming and requires specialized knowledge.",
            "GenAI removes this barrier by automating data interpretation and visualization.",
            "Addresses lack of accessibility and reduces dependency on data scientists or field experts."
        ],
        "Howdoesitwork": [
            "Input: User uploads well log data.",
            "Processing: GenAI interprets data, identifies trends, and generates explanations.",
            {
                mainPoint: "Output: Interactive dashboards with two views:",
                subPoints: [
                    "Overview: High-level summaries for quick decision-making.",
                    "Detailed Analysis: Graphs, trend identification, and human-like explanations."
                ]
            },
            "Supports offline HTML report downloads."

        ],
        "Technologychoices": [
            "Backend: Python",
            "Frontend: Streamlit",
            "Core Technology: Generative AI",
            {
                mainPoint: "Features:",
                subPoints: [
                    "Graph generation",
                    "Data interpretation",
                    "Automation of analysis",
                    "Downloadable reports"
                ]
            }
        ],
        contacts: [
            {
                name: "Shridevi Bale",
                title: "Lead Resources and Energy Industry",
                department: "Advanced Technology Center India",
                image: sridevi
            },
            {
                name: "Srinivasa Chary Daruri",
                title: "Packaged App Development Manager",
                department: "Advanced Technology Center India",
                image: chary
            }
        ]
    }

    return (
        <div className="main-container">
            <div className='In-main-container'>
                <p style={{ marginTop: "30px", fontSize: "28px", marginLeft: "20px", fontWeight: "550", color: "#AD8BFF", fontFamily: "Graphik", width: "1200px", fontSize: "15px" }}>Well Log Analysis</p>

                <div style={{ marginTop: "30px", marginLeft: "140px" }}><img className="i-icon" src={Iicon} onClick={handleToggleModal} /></div>

                {showModal && (
                    <Info
                        onClose={() => setShowModal(false)} infocontent={infocontent}
                    />
                )}
                <div>

                </div>

            </div>
            <div className='container-iframe'>
                <iframe id="kmsembed-1_b4p3wlq2" width="700" height="400" src="https://ts.accenture.com/sites/RES-GENAICommunity/_layouts/15/stream.aspx?id=%2Fsites%2FRES%2DGENAICommunity%2FShared%20Documents%2FGeneral%2FDemo%20recordings%2FWell%20Log%20Data%20Analysis%2Emp4&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E1283cbb0%2D7bd4%2D4a2e%2D961c%2De9ae07c0bf19" class="kmsembed" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" referrerPolicy="no-referrer-when-downgrade" frameborder="0" title="Well Log Data Analysis video"></iframe>
            </div>
        </div>
    )
}

export default WellLogAnalysis